import "./HeroSection.css";
import SectionTitle from "../common/SectionTitle";

const HeroSection = () => {
  return (
    <section id="hero" className="hero-wrapper">
      <div className="hero-container">
        <SectionTitle
          title={
            <>
              Stavební firma
              <span className="section-title-mobile-hide"> · Havlíčkův Brod</span>
            </>
          }
          className="hero-section-title"
        />

        <h1 className="hero-heading">
          Stavíme domy a
          <br />
          měníme ty stávající.
        </h1>

        <p className="hero-description">
          Rodinné a bytové domy na klíč, kompletní rekonstrukce a přestavby.
          Jeden dodavatel a pevný termín.
        </p>

        <div className="hero-info-grid">
          <div className="hero-info-item">
            <span className="hero-info-label">Působíme</span>
            <p className="hero-info-value">Havlíčkův Brod a Vysočina</p>
          </div>

          <div className="hero-info-item">
            <span className="hero-info-label">Specializace</span>
            <p className="hero-info-value">Pozemní stavby a rekonstrukce</p>
          </div>

          <div className="hero-info-item">
            <span className="hero-info-label">Kontakt</span>
            <a href="tel:+420605967051" className="hero-info-value">
              +420 605 967 051
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
